var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitaleyesLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 30,
    viewBox: "0 0 60 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.531 0H15.47C6.926 0 0 6.716 0 15c0 8.284 6.926 15 15.469 15H44.53C53.074 30 60 23.284 60 15c0-8.284-6.926-15-15.469-15z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.986 27.547c7.19 0 13.018-5.653 13.018-12.626 0-6.974-5.828-12.627-13.017-12.627-7.19 0-13.018 5.653-13.018 12.627 0 6.973 5.828 12.626 13.017 12.626zM16.037 27.547c7.19 0 13.018-5.653 13.018-12.626 0-6.974-5.829-12.627-13.018-12.627-7.19 0-13.018 5.653-13.018 12.627 0 6.973 5.828 12.626 13.018 12.626z",
    fill: "#4FBBEB",
    stroke: "#010101",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.986 24.755c5.6 0 10.14-4.403 10.14-9.834s-4.54-9.834-10.14-9.834c-5.599 0-10.138 4.403-10.138 9.834 0 5.43 4.54 9.834 10.139 9.834zM16.037 24.755c5.6 0 10.139-4.403 10.139-9.834s-4.54-9.834-10.14-9.834c-5.599 0-10.138 4.403-10.138 9.834 0 5.43 4.54 9.834 10.139 9.834z",
    fill: "#fff",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.015 20.231c1.688 0 3.058-2.01 3.058-4.49 0-2.48-1.37-4.491-3.058-4.491-1.69 0-3.059 2.01-3.059 4.49 0 2.48 1.37 4.491 3.059 4.491z",
    fill: "#010101"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.793 16.503c.661 0 1.198-.787 1.198-1.759 0-.97-.537-1.758-1.198-1.758-.662 0-1.199.787-1.199 1.758 0 .972.537 1.759 1.198 1.759z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.964 20.231c1.689 0 3.058-2.01 3.058-4.49 0-2.48-1.37-4.491-3.058-4.491-1.689 0-3.058 2.01-3.058 4.49 0 2.48 1.37 4.491 3.058 4.491z",
    fill: "#010101"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.742 16.503c.662 0 1.198-.787 1.198-1.759 0-.97-.536-1.758-1.198-1.758-.662 0-1.198.787-1.198 1.758 0 .972.536 1.759 1.198 1.759z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitaleyesLogo);
export default __webpack_public_path__ + "static/media/digitaleyesLogo.d3289ec61dc00ddf2c2023d28205799c.svg";
export { ForwardRef as ReactComponent };